import { CommonGet, CommonPost } from "../../../../utils/CommonFetch";

export default {
    getAlGroupsForDropdown,
    getFactoriesByGroupID,
    getAllRoutesByFactoryID,
    getAllCollectionTypesByoperationEntityID,
    getCustomerLeafCollectionReportData
};

async function getAlGroupsForDropdown() {
    var groupArray = [];
    const response = await CommonGet('/api/Group/GetAllGroups', null)
    for (let item of Object.entries(response.data)) {
        if (item[1]["isActive"] === true) {
            groupArray[item[1]["groupID"]] = item[1]["groupName"]
        }
    }
    return groupArray;
}

async function getFactoriesByGroupID(groupID) {
    const response = await CommonGet('/api/OperationEntity/GetFactoriesByGroupID','groupID=' + groupID);
    let array = []
    for (let item of Object.entries(response.data)) {
        if (item[1]) {
        array[item[1]["operationEntityID"]] = item[1]["operationEntityName"]
        }
    }
    return array;
}

async function getAllRoutesByFactoryID(factoryID) {
    var routeArray = [];
    const response = await CommonGet('/api/CollectionPoint/GetAllRoutesByFactoryID', 'factoryID=' + factoryID);
    for (let item of Object.entries(response.data)) {
        if (item[1]["isActive"] === true) {
            routeArray[item[1]["collectionPointID"]] = item[1]["collectionPointName"]
        }
    }
    return routeArray;  
}

async function getAllCollectionTypesByoperationEntityID(operationEntityID) {
    var collectionTypeArray = [];
    const response = await CommonGet('/api/CollectionType/GetAllCollectionTypesByOperationEntityID', 'operationEntityID=' + operationEntityID);
    for (let item of Object.entries(response.data)) {
        if (item[1]) {
            collectionTypeArray[item[1]["collectionTypeMasterID"]] = item[1]["collectionTypeName"]
        }
    }
    return collectionTypeArray;  
}

async function getCustomerLeafCollectionReportData(data) {
    var model = {
        factoryID: parseInt(data.factoryID),
        routeID: parseInt(data.routeID),
        searchDate: data.searchDate,
        collectionTypeMasterID: parseInt(data.collectionTypeID)
    };
    const response = await CommonPost('/api/CustomerLeafCollectionRTFReport/GetCustomerLeafRTFCollectionReportData', null, model);
    return response.data;
}